<template lang="pug">
  .height-100
    h3.title Mis Funciones
    p
    template(v-if="!isLoading")
      iframe(:src="path")
        | Oops! an error has occurred.


</template>

<script>
import { apiGet, notify } from '../util/general'
export default {
  name: 'mis-funciones',
  data () {
    return {
      path: '',
      isLoading: true
    }
  },
  watch : {
  },
  created () {
    this.obtenerFuncion()
  },
  methods: {
    obtenerFuncion () {
      var vm = this
      vm.isLoading = true
      var obj = {
        empresa: process.env.EMPRESA,
        codigo: localStorage.getItem('username')
      }
      apiGet(vm, '/funciones_pdf/obtener/funcion', obj, function (data) {
        vm.path = data.funcion.pathPdf
        if (!vm.path.startsWith('http')) {
          vm.path = process.env.API_ROUTE + '/funciones_pdf/mostrarPath?ruta=' + vm.path
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .height-100
    height 100%
    min-height 100%
  iframe
    width 100%
    height: calc(100vh - 150px);
</style>



// WEBPACK FOOTER //
// View_Mis_Funciones.vue?f586baa4